import { put, takeLatest } from "redux-saga/effects";
import { postSignatureRewardConfirmApi } from "store/api/HomeApi";
import { SIGNATURE_REWARD_CONFIRM_ACTION } from "../../actions/HomePageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* signatureRewardConfirmApi(action) {
	const { signature, onSuccess } = action.params;
	yield put(globalAction.openLoadingPage());
	const data = { data: signature };
	const res = yield postSignatureRewardConfirmApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postSignatureRewardConfirmSaga() {
	yield takeLatest(
		SIGNATURE_REWARD_CONFIRM_ACTION,
		signatureRewardConfirmApi
	);
}

export default postSignatureRewardConfirmSaga;
